module.exports = __webpack_public_path__ + "static/media/product_category_29.caf03770.png";